import MuiRadio, {RadioProps} from '@mui/material/Radio';

export const Radio = (props: RadioProps) => {
    return (
        <MuiRadio
            {...props}
        />
    )
}